module.exports = __webpack_public_path__ + "static/img/46-1.2392692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/46-1.jpg
// module id = I19/
// module chunks = 0